const bannerAnimationCompleteEvent = "egf:bannerAnimationComplete";
let isBannerAnimationComplete = false;

function completeBannerAnimation() {
	isBannerAnimationComplete = true;
	window.dispatchEvent(new CustomEvent(bannerAnimationCompleteEvent));
}

function initBannerAnimation() {
	if (typeof gsap === "undefined") {
		completeBannerAnimation();
		return;
	}

	const banner = document.querySelector("#banner");
	if (!banner) {
		completeBannerAnimation();
		return;
	}

	const title = banner.querySelector(".bigTitle");
	const textElements = [...banner.querySelectorAll(".subTitle p, .buttons a")];
	const animatedElements = [title, ...textElements].filter(Boolean);
	const media = gsap.matchMedia();

	media.add("(prefers-reduced-motion: reduce)", () => {
		gsap.set(animatedElements, { clearProps: "all" });
		completeBannerAnimation();
	});

	media.add("(prefers-reduced-motion: no-preference)", () => {
		const timeline = gsap.timeline({
			defaults: {
				duration: 0.62,
				ease: "power3.out",
			},
			onComplete: () => {
				gsap.set(animatedElements, { clearProps: "all" });
				completeBannerAnimation();
			},
		});

		timeline.fromTo(animatedElements, { autoAlpha: 0, y: 24 }, { autoAlpha: 1, y: 0 });

		return () => {
			timeline.kill();
		};
	});
}
function initBannerLPAnimation() {
	if (typeof gsap === "undefined") {
		return;
	}

	const bannerLP = document.querySelector("#bannerLP");
	if (!bannerLP) {
		return;
	}

	const seal = bannerLP.querySelector(".container img");
	const title = bannerLP.querySelector("h1");
	const button = bannerLP.querySelector(".btn");
	const figure = bannerLP.querySelector("figure");
	const image = bannerLP.querySelector("figure img");
	const animatedElements = [seal, title, button, figure, image].filter(Boolean);
	const media = gsap.matchMedia();

	media.add("(prefers-reduced-motion: reduce)", () => {
		gsap.set(animatedElements, { clearProps: "all" });
	});

	media.add("(prefers-reduced-motion: no-preference)", () => {
		const timeline = gsap.timeline({
			defaults: {
				ease: "power3.out",
			},
			onComplete: () => gsap.set(animatedElements, { clearProps: "all" }),
		});

		gsap.set(seal, { autoAlpha: 0, y: 26, scale: 0.9, transformOrigin: "50% 50%" });
		gsap.set(title, { autoAlpha: 0, y: 34 });
		gsap.set(button, { autoAlpha: 0, y: 22 });
		gsap.set(figure, { autoAlpha: 0 });
		gsap.set(image, { scale: 1.04, transformOrigin: "50% 50%" });

		timeline
			.to(figure, { autoAlpha: 1, duration: 0.8 })
			.to(image, { scale: 1, duration: 1.4 }, "-=0.8")
			.to(seal, { autoAlpha: 1, y: 0, scale: 1, duration: 0.7 }, "-=0.9")
			.to(title, { autoAlpha: 1, y: 0, duration: 0.75 }, "-=0.45")
			.to(button, { autoAlpha: 1, y: 0, duration: 0.55 }, "-=0.32");

		return () => timeline.kill();
	});
}
function initEvolutionLPAnimation() {
	if (typeof gsap === "undefined") {
		return;
	}

	const evolution = document.querySelector("#evolution");
	if (!evolution) {
		return;
	}

	const textElements = [...evolution.querySelectorAll(".texts h2, .texts p, .texts .btn")];
	const line = evolution.querySelector(".texts hr");
	const figures = [...evolution.querySelectorAll(".gallery figure")];
	const images = [...evolution.querySelectorAll(".gallery img")];
	const animatedElements = [...textElements, line, ...figures, ...images].filter(Boolean);
	const media = gsap.matchMedia();

	media.add("(prefers-reduced-motion: reduce)", () => {
		gsap.set(animatedElements, { clearProps: "all" });
	});

	media.add("(prefers-reduced-motion: no-preference)", () => {
		const timeline = gsap.timeline({
			paused: true,
			defaults: {
				ease: "power3.out",
			},
			onComplete: () => gsap.set(animatedElements, { clearProps: "all" }),
		});

		gsap.set(textElements, { autoAlpha: 0, y: 30 });
		gsap.set(line, { scaleX: 0, transformOrigin: "left center" });
		gsap.set(figures, { autoAlpha: 0, y: 34, clipPath: "inset(8% 0 0 0)" });
		gsap.set(images, { scale: 1.035, transformOrigin: "50% 50%" });

		timeline
			.to(textElements, { autoAlpha: 1, y: 0, duration: 0.68, stagger: 0.09 })
			.to(line, { scaleX: 1, duration: 0.72 }, "-=0.35")
			.to(figures, { autoAlpha: 1, y: 0, clipPath: "inset(0% 0 0 0)", duration: 0.72, stagger: 0.08 }, "-=0.55")
			.to(images, { scale: 1, duration: 0.95, stagger: 0.05 }, "-=0.82");

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					return;
				}

				timeline.play();
				observer.disconnect();
			});
		}, { threshold: 0.25 });

		observer.observe(evolution);

		return () => {
			observer.disconnect();
			timeline.kill();
		};
	});
}
function initServicesAnimation() {
	if (typeof gsap === "undefined") {
		return;
	}

	const services = document.querySelector("#services");
	if (!services) {
		return;
	}

	const cards = [...services.querySelectorAll(".servicesCards > li")];
	if (!cards.length) {
		return;
	}

	const animatedElements = cards;
	const media = gsap.matchMedia();

	media.add("(prefers-reduced-motion: reduce)", () => {
		gsap.set(animatedElements, { clearProps: "all" });
	});

	media.add("(prefers-reduced-motion: no-preference)", () => {
		const timeline = gsap.timeline({
			paused: true,
			defaults: {
				ease: "power3.out",
			},
			onComplete: () => gsap.set(animatedElements, { clearProps: "all" }),
		});

		gsap.set(cards, { autoAlpha: 0, y: 28, scale: 0.985, pointerEvents: "none", transformOrigin: "50% 100%" });

		timeline.to(cards, { autoAlpha: 1, y: 0, scale: 1, duration: 0.68, stagger: { amount: 0.1, from: "center" } });

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					return;
				}

				if (isBannerAnimationComplete) {
					timeline.play();
				} else {
					window.addEventListener(bannerAnimationCompleteEvent, () => timeline.play(), { once: true });
				}

				observer.disconnect();
			});
		}, { threshold: 0.22 });

		observer.observe(services);

		return () => {
			observer.disconnect();
			timeline.kill();
		};
	});
}
function initHatLinesAnimation() {
	if (typeof gsap === "undefined") {
		return;
	}

	const hats = [...document.querySelectorAll(".hat")];
	if (!hats.length) {
		return;
	}

	const media = gsap.matchMedia();

	function splitHatChars(hat) {
		const text = hat.textContent.trim();
		const fragment = document.createDocumentFragment();
		const chars = [...text].map((char) => {
			if (char === " ") {
				fragment.appendChild(document.createTextNode(" "));
				return null;
			}

			const span = document.createElement("span");
			span.className = "hat__char";
			span.setAttribute("aria-hidden", "true");
			span.textContent = char;
			fragment.appendChild(span);

			return span;
		}).filter(Boolean);

		hat.setAttribute("aria-label", text);
		hat.textContent = "";
		hat.appendChild(fragment);

		return chars;
	}

	media.add("(prefers-reduced-motion: reduce)", () => {
		gsap.set(hats, { clearProps: "--hat-alpha,--hat-y,--hat-before-alpha,--hat-before-y,--hat-after-alpha,--hat-after-x,--hat-after-y,--hat-after-scale" });
	});

	media.add("(prefers-reduced-motion: no-preference)", () => {
		const timelines = new Map();
		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					return;
				}

				const timeline = timelines.get(entry.target);
				if (timeline) {
					timeline.play();
				}

				observer.unobserve(entry.target);
			});
		}, { threshold: 0.35 });

		hats.forEach((hat) => {
			const chars = splitHatChars(hat);
			const timeline = gsap.timeline({
				paused: true,
				defaults: {
					ease: "power3.out",
				},
				onComplete: () => {
					gsap.set(hat, { clearProps: "--hat-alpha,--hat-y,--hat-before-alpha,--hat-before-y,--hat-after-alpha,--hat-after-x,--hat-after-y,--hat-after-scale" });
					gsap.set(chars, { clearProps: "all" });
				},
			});

			gsap.set(hat, {
				"--hat-before-alpha": 0,
				"--hat-before-y": "-8px",
				"--hat-after-alpha": 0,
				"--hat-after-x": "-7px",
				"--hat-after-y": "-4px",
				"--hat-after-scale": 0.25,
			});
			gsap.set(chars, { autoAlpha: 0, y: 8 });

			timeline
				.to(chars, { autoAlpha: 1, y: 0, duration: 0.38, stagger: 0.025, delay: 0.2 })
				.to(hat, { "--hat-before-alpha": 1, "--hat-before-y": "0px", duration: 0.46 }, "-=0.02")
				.to(hat, { "--hat-after-alpha": 1, "--hat-after-x": "0px", "--hat-after-y": "0px", "--hat-after-scale": 1, duration: 0.5 }, "-=0.1");

			timelines.set(hat, timeline);
			observer.observe(hat);
		});

		return () => {
			observer.disconnect();
			timelines.forEach((timeline) => timeline.kill());
		};
	});
}
function initDeliverAnimation() {
	if (typeof gsap === "undefined") {
		return;
	}

	const deliver = document.querySelector("#weDeliver");
	if (!deliver) {
		return;
	}

	const topElements = [...deliver.querySelectorAll(".top .hat, .top h2, .top p")];
	const cards = [...deliver.querySelectorAll(".deliverCards > li")];
	const vector = deliver.querySelector(".vector");
	const animatedElements = [...topElements, ...cards, vector].filter(Boolean);
	const media = gsap.matchMedia();

	media.add("(prefers-reduced-motion: reduce)", () => {
		gsap.set(animatedElements, { clearProps: "all" });
	});

	media.add("(prefers-reduced-motion: no-preference)", () => {
		const timeline = gsap.timeline({
			paused: true,
			defaults: {
				ease: "power3.out",
			},
			onComplete: () => gsap.set(animatedElements, { clearProps: "all" }),
		});

		gsap.set(topElements, { autoAlpha: 0, y: 30 });
		gsap.set(cards, { autoAlpha: 0, y: 28, scale: 0.985, pointerEvents: "none", transformOrigin: "50% 100%" });
		gsap.set(vector, { autoAlpha: 0, scaleY: 0.92, transformOrigin: "center top" });

		timeline
			.to(topElements, { autoAlpha: 1, y: 0, duration: 0.68, stagger: 0.09 })
			.to(vector, { autoAlpha: 1, scaleY: 1, duration: 0.9 }, "-=0.45")
			.to(cards, { autoAlpha: 1, y: 0, scale: 1, duration: 0.64, stagger: { amount: 0.1, from: "center" } }, "-=0.55");

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					return;
				}

				timeline.play();
				observer.disconnect();
			});
		}, { threshold: 0.25 });

		observer.observe(deliver);

		return () => {
			observer.disconnect();
			timeline.kill();
		};
	});
}
function initControlAnimation() {
	if (typeof gsap === "undefined") {
		return;
	}

	const control = document.querySelector("#control");
	if (!control) {
		return;
	}

	const topElements = [...control.querySelectorAll(".top .hat, .top h2, .top p")];
	const cards = [...control.querySelectorAll(".controlCards > li")];
	const animatedElements = [...topElements, ...cards].filter(Boolean);
	const media = gsap.matchMedia();

	media.add("(prefers-reduced-motion: reduce)", () => {
		gsap.set(animatedElements, { clearProps: "all" });
	});

	media.add("(prefers-reduced-motion: no-preference)", () => {
		const timeline = gsap.timeline({
			paused: true,
			defaults: {
				ease: "power3.out",
			},
			onComplete: () => gsap.set(animatedElements, { clearProps: "all" }),
		});

		gsap.set(topElements, { autoAlpha: 0, y: 30 });
		gsap.set(cards, { autoAlpha: 0, y: 30, scale: 0.985, pointerEvents: "none", transformOrigin: "50% 100%" });

		timeline
			.to(topElements, { autoAlpha: 1, y: 0, duration: 0.68, stagger: 0.09 })
			.to(cards, { autoAlpha: 1, y: 0, scale: 1, duration: 0.64, stagger: { amount: 0.08, from: "center" } }, "-=0.32");

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					return;
				}

				timeline.play();
				observer.disconnect();
			});
		}, { threshold: 0.25 });

		observer.observe(control);

		return () => {
			observer.disconnect();
			timeline.kill();
		};
	});
}
function initInstitutionalCycleAnimation() {
	if (typeof gsap === "undefined") {
		return;
	}

	const institutionalCycle = document.querySelector("#institutionalCycle");
	if (!institutionalCycle) {
		return;
	}

	const leftElements = [...institutionalCycle.querySelectorAll(".institutionalCycle__left h2, .institutionalCycle__left p")];
	const leftLine = institutionalCycle.querySelector(".institutionalCycle__left hr");
	const mark = institutionalCycle.querySelector(".institutionalCycle__mark img");
	const rightText = institutionalCycle.querySelector(".institutionalCycle__right p");
	const rightLine = institutionalCycle.querySelector(".institutionalCycle__right hr");
	const bars = [...institutionalCycle.querySelectorAll(".institutionalCycle__bars span")];
	const vector = institutionalCycle.querySelector(".institutionalCycle__bars img");
	const animatedElements = [...leftElements, leftLine, mark, rightText, rightLine, ...bars, vector].filter(Boolean);
	const media = gsap.matchMedia();

	media.add("(prefers-reduced-motion: reduce)", () => {
		gsap.set(animatedElements, { clearProps: "all" });
	});

	media.add("(prefers-reduced-motion: no-preference)", () => {
		const timeline = gsap.timeline({
			paused: true,
			defaults: {
				ease: "power3.out",
			},
			onComplete: () => gsap.set(animatedElements, { clearProps: "all" }),
		});

		gsap.set(leftElements, { autoAlpha: 0, y: 32 });
		gsap.set(leftLine, { scaleX: 0, transformOrigin: "left center" });
		gsap.set(mark, { autoAlpha: 0, scale: 0.82, rotate: -4, transformOrigin: "50% 50%" });
		gsap.set(rightText, { autoAlpha: 0, y: 30 });
		gsap.set(rightLine, { scaleX: 0, transformOrigin: "left center" });
		gsap.set(bars, { scaleY: 0, transformOrigin: "bottom center" });
		gsap.set(vector, { autoAlpha: 0, clipPath: "inset(0 100% 0 0)" });

		timeline
			.to(leftElements, { autoAlpha: 1, y: 0, duration: 0.68, stagger: 0.1 })
			.to(leftLine, { scaleX: 1, duration: 0.72 }, "-=0.35")
			.to(mark, { autoAlpha: 1, scale: 1, rotate: 0, duration: 0.75 }, "-=0.62")
			.to(rightText, { autoAlpha: 1, y: 0, duration: 0.68 }, "-=0.35")
			.to(rightLine, { scaleX: 1, duration: 0.7 }, "-=0.3")
			.to(bars, { scaleY: 1, duration: 0.85, stagger: 0.08 }, "-=0.35")
			.to(vector, { autoAlpha: 1, clipPath: "inset(0 0% 0 0)", duration: 0.95 }, "-=0.85");

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					return;
				}

				timeline.play();
				observer.disconnect();
			});
		}, { threshold: 0.25 });

		observer.observe(institutionalCycle);

		return () => {
			observer.disconnect();
			timeline.kill();
		};
	});
}
function initAboutAnimation() {
	if (typeof gsap === "undefined") {
		return;
	}

	const about = document.querySelector("#about");
	if (!about) {
		return;
	}

	const contentElements = [
		about.querySelector(".about__content h2"),
		...about.querySelectorAll(".about__description p"),
		about.querySelector(".about__content .btn"),
	].filter(Boolean);
	const numbers = [...about.querySelectorAll(".about__numbers li")];
	const image = about.querySelector(".about__image");
	const badge = about.querySelector(".about__badge");
	const caption = about.querySelector(".about__media figcaption");
	const animatedElements = [...contentElements, ...numbers, image, badge, caption].filter(Boolean);
	const media = gsap.matchMedia();

	media.add("(prefers-reduced-motion: reduce)", () => {
		gsap.set(animatedElements, { clearProps: "all" });
	});

	media.add("(prefers-reduced-motion: no-preference)", () => {
		const timeline = gsap.timeline({
			paused: true,
			defaults: {
				ease: "power3.out",
			},
			onComplete: () => gsap.set(animatedElements, { clearProps: "all" }),
		});

		gsap.set(contentElements, { autoAlpha: 0, y: 24 });
		gsap.set(numbers, { autoAlpha: 0, y: 22 });
		gsap.set(image, { autoAlpha: 0, y: 26, scale: 0.985, transformOrigin: "50% 100%" });
		gsap.set(badge, { autoAlpha: 0 });
		gsap.set(caption, { autoAlpha: 0, y: -64 });

		timeline
			.to(image, { autoAlpha: 1, y: 0, scale: 1, duration: 0.7 })
			.to(badge, { autoAlpha: 1, duration: 0.4 }, "-=0.45")
			.to(caption, { autoAlpha: 1, y: 0, duration: 0.58 }, "-=0.25")
			.to(contentElements, { autoAlpha: 1, y: 0, duration: 0.62, stagger: 0.06 }, "-=0.55")
			.to(numbers, { autoAlpha: 1, y: 0, duration: 0.48, stagger: 0.1 }, "-=0.18");

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					return;
				}

				timeline.play();
				observer.disconnect();
			});
		}, { threshold: 0.35 });

		observer.observe(about);

		return () => {
			observer.disconnect();
			timeline.kill();
		};
	});
}
function initAboutInsideAnimation() {
	if (typeof gsap === "undefined") {
		return;
	}

	const aboutInside = document.querySelector("#aboutInside");
	if (!aboutInside) {
		return;
	}

	const leftElements = [...aboutInside.querySelectorAll(".boxLeft .hat, .boxLeft h1, .boxLeft p, .boxLeft .btn")];
	const vector = aboutInside.querySelector(".boxLeft .vector");
	const line = aboutInside.querySelector(".boxLeft hr");
	const images = [...aboutInside.querySelectorAll(".boxRight img")];
	const bottomLine = aboutInside.querySelector(".container > hr");
	const animatedElements = [...leftElements, vector, line, ...images, bottomLine].filter(Boolean);
	const media = gsap.matchMedia();

	media.add("(prefers-reduced-motion: reduce)", () => {
		gsap.set(animatedElements, { clearProps: "all" });
	});

	media.add("(prefers-reduced-motion: no-preference)", () => {
		const timeline = gsap.timeline({
			paused: true,
			defaults: {
				ease: "power3.out",
			},
			onComplete: () => gsap.set(animatedElements, { clearProps: "all" }),
		});

		gsap.set(leftElements, { autoAlpha: 0, y: 30 });
		gsap.set(vector, { autoAlpha: 0, x: -28 });
		gsap.set(line, { scaleX: 0, transformOrigin: "left center" });
		gsap.set(images, { autoAlpha: 0, y: 36, clipPath: "inset(10% 0 0 0)" });
		gsap.set(bottomLine, { scaleX: 0, transformOrigin: "left center" });

		timeline
			.to(leftElements, { autoAlpha: 1, y: 0, duration: 0.68, stagger: 0.09 })
			.to(vector, { autoAlpha: 1, x: 0, duration: 0.85 }, "-=0.45")
			.to(line, { scaleX: 1, duration: 0.72 }, "-=0.6")
			.to(images, { autoAlpha: 1, y: 0, clipPath: "inset(0% 0 0 0)", duration: 0.75, stagger: 0.1 }, "-=0.75")
			.to(bottomLine, { scaleX: 1, duration: 0.8 }, "-=0.45");

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					return;
				}

				timeline.play();
				observer.disconnect();
			});
		}, { threshold: 0.25 });

		observer.observe(aboutInside);

		return () => {
			observer.disconnect();
			timeline.kill();
		};
	});
}
function initAegfPageAnimation() {
	if (typeof gsap === "undefined") {
		return;
	}

	const topInside = document.querySelector("#topInside.aegf");
	const aboutInside = document.querySelector("#aboutInside");
	const clients = document.querySelector("#about .about__clients");
	if (!topInside && !aboutInside && !clients) {
		return;
	}

	const media = gsap.matchMedia();

	media.add("(prefers-reduced-motion: reduce)", () => {
		const elements = [
			topInside?.querySelector(".mediumTitle"),
			...(topInside?.querySelectorAll(".breadcrumble > *") || []),
			topInside?.querySelector(".bg"),
			...(aboutInside?.querySelectorAll(".about__content h2, .about__description p, .about__numbers li, .aboutTimeline__item") || []),
			clients?.querySelector("h2"),
			clients?.querySelector(".about__clientsMarquee"),
		].filter(Boolean);

		gsap.set(elements, { clearProps: "all" });
	});

	media.add("(prefers-reduced-motion: no-preference)", () => {
		const timelines = [];
		const observers = [];

		function playOnView(section, timeline, threshold = 0.25) {
			if (!section) {
				return;
			}

			const observer = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (!entry.isIntersecting) {
						return;
					}

					timeline.play();
					observer.disconnect();
				});
			}, { threshold });

			observer.observe(section);
			observers.push(observer);
		}

		if (topInside) {
			const title = topInside.querySelector(".mediumTitle");
			const breadcrumbItems = [...topInside.querySelectorAll(".breadcrumble > *")];
			const background = topInside.querySelector(".bg");
			const heroElements = [title, ...breadcrumbItems, background].filter(Boolean);
			const timeline = gsap.timeline({
				defaults: {
					ease: "power3.out",
				},
				onComplete: () => gsap.set(heroElements, { clearProps: "all" }),
			});

			gsap.set(title, { autoAlpha: 0, y: 32 });
			gsap.set(breadcrumbItems, { autoAlpha: 0, y: 16 });
			gsap.set(background, { autoAlpha: 0, scale: 1.04, transformOrigin: "50% 50%" });

			timeline
				.to(background, { autoAlpha: 1, scale: 1, duration: 1.15 })
				.to(title, { autoAlpha: 1, y: 0, duration: 0.72 }, "-=0.78")
				.to(breadcrumbItems, { autoAlpha: 1, y: 0, duration: 0.42, stagger: 0.055 }, "-=0.38");

			timelines.push(timeline);
		}

		if (aboutInside) {
			const contentElements = [
				aboutInside.querySelector(".about__content h2"),
				...aboutInside.querySelectorAll(".about__description p"),
			].filter(Boolean);
			const numbers = [...aboutInside.querySelectorAll(".about__numbers li")];
			const timelineItems = [...aboutInside.querySelectorAll(".aboutTimeline__item")];
			const introElements = [...contentElements, ...numbers];

			if (introElements.length) {
				const introTimeline = gsap.timeline({
					paused: true,
					defaults: {
						ease: "power3.out",
					},
					onComplete: () => gsap.set(introElements, { clearProps: "all" }),
				});

				gsap.set(contentElements, { autoAlpha: 0, y: 28 });
				gsap.set(numbers, { autoAlpha: 0, y: 22, scale: 0.985, transformOrigin: "50% 100%" });

				introTimeline
					.to(contentElements, { autoAlpha: 1, y: 0, duration: 0.62, stagger: 0.07 })
					.to(numbers, { autoAlpha: 1, y: 0, scale: 1, duration: 0.52, stagger: 0.07 }, "-=0.28");

				timelines.push(introTimeline);
				playOnView(aboutInside, introTimeline, 0.22);
			}

			timelineItems.forEach((item) => {
				const figure = item.querySelector("figure");
				const image = item.querySelector("img");
				const content = item.querySelector(".aboutTimeline__content");
				const itemElements = [figure, image, content].filter(Boolean);
				const timeline = gsap.timeline({
					paused: true,
					defaults: {
						ease: "power3.out",
					},
					onComplete: () => gsap.set(itemElements, { clearProps: "all" }),
				});

				gsap.set(figure, { autoAlpha: 0, y: 30, clipPath: "inset(10% 0 0 0)" });
				gsap.set(image, { scale: 1.035, transformOrigin: "50% 50%" });
				gsap.set(content, { autoAlpha: 0, y: 24 });

				timeline
					.to(figure, { autoAlpha: 1, y: 0, clipPath: "inset(0% 0 0 0)", duration: 0.66 })
					.to(image, { scale: 1, duration: 0.9 }, "-=0.66")
					.to(content, { autoAlpha: 1, y: 0, duration: 0.56 }, "-=0.42");

				timelines.push(timeline);
				playOnView(item, timeline, 0.28);
			});
		}

		if (clients) {
			const title = clients.querySelector("h2");
			const marquee = clients.querySelector(".about__clientsMarquee");
			const clientsElements = [title, marquee].filter(Boolean);
			const timeline = gsap.timeline({
				paused: true,
				defaults: {
					ease: "power3.out",
				},
				onComplete: () => gsap.set(clientsElements, { clearProps: "all" }),
			});

			gsap.set(title, { autoAlpha: 0, y: 26 });
			gsap.set(marquee, { autoAlpha: 0, y: 24 });

			timeline
				.to(title, { autoAlpha: 1, y: 0, duration: 0.62 })
				.to(marquee, { autoAlpha: 1, y: 0, duration: 0.58 }, "-=0.3");

			timelines.push(timeline);
			playOnView(clients, timeline, 0.25);
		}

		return () => {
			observers.forEach((observer) => observer.disconnect());
			timelines.forEach((timeline) => timeline.kill());
		};
	});
}
function initObrasPageAnimation() {
	if (typeof gsap === "undefined") {
		return;
	}

	const topInside = document.querySelector("#topInside.obras-corporativos, #topInside.imobiliaria, #topInside.saneamento");
	const serviceArea = document.querySelector("#serviceArea");
	const servicesExecuted = document.querySelector("#servicesExecuted");
	const operationalManagement = document.querySelector("#operationalManagement");
	const othersServices = document.querySelector("#othersServices");
	if (!topInside && !serviceArea && !servicesExecuted && !operationalManagement && !othersServices) {
		return;
	}

	const media = gsap.matchMedia();

	media.add("(prefers-reduced-motion: reduce)", () => {
		const elements = [
			topInside?.querySelector(".mediumTitle"),
			...(topInside?.querySelectorAll(".breadcrumble > *") || []),
			topInside?.querySelector(".bg"),
			...(serviceArea?.querySelectorAll(".serviceArea__intro h2, .serviceArea__text p, .serviceArea__image, .serviceArea__image img, .serviceArea__list h3, .serviceArea__list li") || []),
			...(servicesExecuted?.querySelectorAll(".servicesExecuted__top h2, .servicesExecuted__swiper, .servicesExecuted__list li") || []),
			operationalManagement?.querySelector(".operationalManagement__bg"),
			...(operationalManagement?.querySelectorAll(".operationalManagement__top h2, .operationalManagement__list li") || []),
			othersServices?.querySelector(".smallTitle"),
			...(othersServices?.querySelectorAll(".servicesCards > li") || []),
		].filter(Boolean);

		gsap.set(elements, { clearProps: "all" });
	});

	media.add("(prefers-reduced-motion: no-preference)", () => {
		const timelines = [];
		const observers = [];

		function playOnView(section, timeline, threshold = 0.25) {
			if (!section) {
				return;
			}

			const observer = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (!entry.isIntersecting) {
						return;
					}

					timeline.play();
					observer.disconnect();
				});
			}, { threshold });

			observer.observe(section);
			observers.push(observer);
		}

		if (topInside) {
			const title = topInside.querySelector(".mediumTitle");
			const breadcrumbItems = [...topInside.querySelectorAll(".breadcrumble > *")];
			const background = topInside.querySelector(".bg");
			const heroElements = [title, ...breadcrumbItems, background].filter(Boolean);
			const timeline = gsap.timeline({
				defaults: {
					ease: "power3.out",
				},
				onComplete: () => gsap.set(heroElements, { clearProps: "all" }),
			});

			gsap.set(title, { autoAlpha: 0, y: 32 });
			gsap.set(breadcrumbItems, { autoAlpha: 0, y: 16 });
			gsap.set(background, { autoAlpha: 0, scale: 1.04, transformOrigin: "50% 50%" });

			timeline
				.to(background, { autoAlpha: 1, scale: 1, duration: 1.15 })
				.to(title, { autoAlpha: 1, y: 0, duration: 0.72 }, "-=0.78")
				.to(breadcrumbItems, { autoAlpha: 1, y: 0, duration: 0.42, stagger: 0.055 }, "-=0.38");

			timelines.push(timeline);
		}

		if (serviceArea) {
			const textElements = [
				serviceArea.querySelector(".serviceArea__intro h2"),
				...serviceArea.querySelectorAll(".serviceArea__text p"),
				serviceArea.querySelector(".serviceArea__list h3"),
			].filter(Boolean);
			const figure = serviceArea.querySelector(".serviceArea__image");
			const image = serviceArea.querySelector(".serviceArea__image img");
			const items = [...serviceArea.querySelectorAll(".serviceArea__list li")];
			const serviceElements = [...textElements, figure, image, ...items].filter(Boolean);
			const timeline = gsap.timeline({
				paused: true,
				defaults: {
					ease: "power3.out",
				},
				onComplete: () => gsap.set(serviceElements, { clearProps: "all" }),
			});

			gsap.set(textElements, { autoAlpha: 0, y: 28 });
			gsap.set(figure, { autoAlpha: 0, y: 30, clipPath: "inset(10% 0 0 0)" });
			gsap.set(image, { scale: 1.035, transformOrigin: "50% 50%" });
			gsap.set(items, { autoAlpha: 0, y: 18 });

			timeline
				.to(textElements, { autoAlpha: 1, y: 0, duration: 0.62, stagger: 0.07 })
				.to(figure, { autoAlpha: 1, y: 0, clipPath: "inset(0% 0 0 0)", duration: 0.68 }, "-=0.42")
				.to(image, { scale: 1, duration: 0.95 }, "-=0.68")
				.to(items, { autoAlpha: 1, y: 0, duration: 0.44, stagger: 0.045 }, "-=0.3");

			timelines.push(timeline);
			playOnView(serviceArea, timeline, 0.22);
		}

		if (servicesExecuted) {
			const topElements = [...servicesExecuted.querySelectorAll(".servicesExecuted__top h2")];
			const swiper = servicesExecuted.querySelector(".servicesExecuted__swiper");
			const cards = [...servicesExecuted.querySelectorAll(".servicesExecuted__list li")];
			const serviceElements = [...topElements, swiper, ...cards].filter(Boolean);
			const timeline = gsap.timeline({
				paused: true,
				defaults: {
					ease: "power3.out",
				},
				onComplete: () => gsap.set(serviceElements, { clearProps: "all" }),
			});

			gsap.set(topElements, { autoAlpha: 0, y: 26 });
			gsap.set(swiper, { autoAlpha: 0, y: 24 });
			gsap.set(cards, { y: 24, scale: 0.985, transformOrigin: "50% 100%" });

			timeline
				.to(topElements, { autoAlpha: 1, y: 0, duration: 0.62 })
				.to(swiper, { autoAlpha: 1, y: 0, duration: 0.58 }, "-=0.3")
				.to(cards, { y: 0, scale: 1, duration: 0.56, stagger: 0.06 }, "-=0.46");

			timelines.push(timeline);
			playOnView(servicesExecuted, timeline, 0.24);
		}

		if (operationalManagement) {
			const background = operationalManagement.querySelector(".operationalManagement__bg");
			const title = operationalManagement.querySelector(".operationalManagement__top h2");
			const items = [...operationalManagement.querySelectorAll(".operationalManagement__list li")];
			const managementElements = [background, title, ...items].filter(Boolean);
			const timeline = gsap.timeline({
				paused: true,
				defaults: {
					ease: "power3.out",
				},
				onComplete: () => gsap.set(managementElements, { clearProps: "all" }),
			});

			gsap.set(background, { scale: 1.035, transformOrigin: "50% 50%" });
			gsap.set(title, { autoAlpha: 0, y: 26 });
			gsap.set(items, { autoAlpha: 0, y: 18 });

			timeline
				.to(background, { scale: 1, duration: 1.2 })
				.to(title, { autoAlpha: 1, y: 0, duration: 0.62 }, "-=0.9")
				.to(items, { autoAlpha: 1, y: 0, duration: 0.45, stagger: 0.05 }, "-=0.3");

			timelines.push(timeline);
			playOnView(operationalManagement, timeline, 0.25);
		}

		if (othersServices) {
			const title = othersServices.querySelector(".smallTitle");
			const cards = [...othersServices.querySelectorAll(".servicesCards > li")];
			const otherElements = [title, ...cards].filter(Boolean);
			const timeline = gsap.timeline({
				paused: true,
				defaults: {
					ease: "power3.out",
				},
				onComplete: () => gsap.set(otherElements, { clearProps: "all" }),
			});

			gsap.set(title, { autoAlpha: 0, y: 26 });
			gsap.set(cards, { autoAlpha: 0, y: 28, scale: 0.985, transformOrigin: "50% 100%" });

			timeline
				.to(title, { autoAlpha: 1, y: 0, duration: 0.58 })
				.to(cards, { autoAlpha: 1, y: 0, scale: 1, duration: 0.62, stagger: { amount: 0.1, from: "center" } }, "-=0.24");

			timelines.push(timeline);
			playOnView(othersServices, timeline, 0.22);
		}

		return () => {
			observers.forEach((observer) => observer.disconnect());
			timelines.forEach((timeline) => timeline.kill());
		};
	});
}
function initContextAnimation() {
	if (typeof gsap === "undefined") {
		return;
	}

	const context = document.querySelector("#context");
	if (!context) {
		return;
	}

	const leftElements = [...context.querySelectorAll(".boxLeft h2, .boxLeft p")];
	const line = context.querySelector(".boxLeft hr");
	const rightElements = [...context.querySelectorAll(".boxRight p")];
	const building = context.querySelector(".bottom figure");
	const vector = context.querySelector(".bottom .vector");
	const animatedElements = [...leftElements, line, ...rightElements, building, vector].filter(Boolean);
	const media = gsap.matchMedia();

	media.add("(prefers-reduced-motion: reduce)", () => {
		gsap.set(animatedElements, { clearProps: "all" });
	});

	media.add("(prefers-reduced-motion: no-preference)", () => {
		const timeline = gsap.timeline({
			paused: true,
			defaults: {
				ease: "power3.out",
			},
			onComplete: () => gsap.set(animatedElements, { clearProps: "all" }),
		});

		gsap.set(leftElements, { autoAlpha: 0, y: 34 });
		gsap.set(line, { scaleX: 0, transformOrigin: "left center" });
		gsap.set(rightElements, { autoAlpha: 0, y: 30 });
		gsap.set(building, { autoAlpha: 0, y: 52, scale: 0.96, transformOrigin: "50% 100%" });
		gsap.set(vector, { autoAlpha: 0, scaleX: 0.92, transformOrigin: "center center" });

		timeline
			.to(leftElements, { autoAlpha: 1, y: 0, duration: 0.65, stagger: 0.1 })
			.to(line, { scaleX: 1, duration: 0.75 }, "-=0.35")
			.to(rightElements, { autoAlpha: 1, y: 0, duration: 0.72, stagger: 0.14 }, "-=0.55")
			.to(vector, { autoAlpha: 1, scaleX: 1, duration: 0.9 }, "-=0.25")
			.to(building, { autoAlpha: 1, y: 0, scale: 1, duration: 0.6 }, "-=1.05");

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					return;
				}

				timeline.play();
				observer.disconnect();
			});
		}, { threshold: 0.3 });

		observer.observe(context);

		return () => {
			observer.disconnect();
			timeline.kill();
		};
	});
}
function initSecurityAnimation() {
	if (typeof gsap === "undefined") {
		return;
	}

	const security = document.querySelector("#security");
	if (!security) {
		return;
	}

	const text = security.querySelector("small");
	if (!text) {
		return;
	}

	const media = gsap.matchMedia();

	media.add("(prefers-reduced-motion: reduce)", () => {
		gsap.set(text, { clearProps: "all" });
	});

	media.add("(prefers-reduced-motion: no-preference)", () => {
		const timeline = gsap.timeline({
			paused: true,
			delay: 0.25,
			defaults: {
				ease: "power3.out",
			},
			onComplete: () => gsap.set(text, { clearProps: "all" }),
		});

		gsap.set(text, { autoAlpha: 0, y: 18, clipPath: "inset(0 100% 0 0)" });

		timeline.to(text, {
			autoAlpha: 0.6,
			y: 0,
			clipPath: "inset(0 0% 0 0)",
			duration: 0.9,
		});

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					return;
				}

				timeline.play();
				observer.disconnect();
			});
		}, { threshold: 0.45 });

		observer.observe(security);

		return () => {
			observer.disconnect();
			timeline.kill();
		};
	});
}
function initAreasAnimation() {
	if (typeof gsap === "undefined") {
		return;
	}

	const areas = document.querySelector("#areas");
	if (!areas) {
		return;
	}

	const textElements = [...areas.querySelectorAll(".texts h2, .texts p, .texts .btn")];
	const vector = areas.querySelector(".texts .vector");
	const items = [...areas.querySelectorAll("ul li")];
	const itemContent = items.flatMap((item) => [...item.querySelectorAll("img, h3")]);
	const animatedElements = [...textElements, vector, ...items, ...itemContent].filter(Boolean);
	const media = gsap.matchMedia();

	media.add("(prefers-reduced-motion: reduce)", () => {
		gsap.set(animatedElements, { clearProps: "all" });
	});

	media.add("(prefers-reduced-motion: no-preference)", () => {
		const timeline = gsap.timeline({
			paused: true,
			defaults: {
				ease: "power3.out",
			},
			onComplete: () => gsap.set(animatedElements, { clearProps: "all" }),
		});

		gsap.set(textElements, { autoAlpha: 0, y: 30 });
		gsap.set(vector, { autoAlpha: 0, scaleY: 0, transformOrigin: "top center" });
		gsap.set(items, { autoAlpha: 0, y: 34, clipPath: "inset(12% 0 0 0)" });
		gsap.set(itemContent, { autoAlpha: 0, y: 18 });

		timeline
			.to(textElements, { autoAlpha: 1, y: 0, duration: 0.72, stagger: 0.1 })
			.to(vector, { autoAlpha: 1, scaleY: 1, duration: 1 }, "-=0.35")
			.to(items, { autoAlpha: 1, y: 0, clipPath: "inset(0% 0 0 0)", duration: 0.7, stagger: 0.1 }, "-=0.75")
			.to(itemContent, { autoAlpha: 1, y: 0, duration: 0.55, stagger: 0.04 }, "-=0.55");

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					return;
				}

				timeline.play();
				observer.disconnect();
			});
		}, { threshold: 0.3 });

		observer.observe(areas);

		return () => {
			observer.disconnect();
			timeline.kill();
		};
	});
}
function initAreasInsideAnimation() {
	if (typeof gsap === "undefined") {
		return;
	}

	const areasInside = document.querySelector("#areasInside");
	if (!areasInside) {
		return;
	}

	const topTitle = areasInside.querySelector(".top .titleBox h2");
	const topArrow = areasInside.querySelector(".top .titleBox img");
	const topTexts = [...areasInside.querySelectorAll(".top .texts p")];
	const items = [...areasInside.querySelectorAll("ul li")];
	const itemTitles = items.map((item) => item.querySelector(".title")).filter(Boolean);
	const itemTitleContent = items.flatMap((item) => [...item.querySelectorAll(".title img, .title h3")]);
	const itemTexts = items.flatMap((item) => [...item.querySelectorAll(".texts p")]);
	const animatedElements = [topTitle, topArrow, ...topTexts, ...items, ...itemTitles, ...itemTitleContent, ...itemTexts].filter(Boolean);
	const media = gsap.matchMedia();

	media.add("(prefers-reduced-motion: reduce)", () => {
		gsap.set(animatedElements, { clearProps: "all" });
	});

	media.add("(prefers-reduced-motion: no-preference)", () => {
		const timeline = gsap.timeline({
			paused: true,
			defaults: {
				ease: "power3.out",
			},
			onComplete: () => gsap.set(animatedElements, { clearProps: "all" }),
		});

		gsap.set(topTitle, { autoAlpha: 0, y: 30 });
		gsap.set(topArrow, { autoAlpha: 0, y: -18, scale: 0.86, transformOrigin: "50% 50%" });
		gsap.set(topTexts, { autoAlpha: 0, y: 26 });
		gsap.set(items, { autoAlpha: 0, y: 34, clipPath: "inset(8% 0 0 0)" });
		gsap.set(itemTitles, { x: -28 });
		gsap.set(itemTitleContent, { autoAlpha: 0, x: -18 });
		gsap.set(itemTexts, { autoAlpha: 0, y: 18 });

		timeline
			.to(topTitle, { autoAlpha: 1, y: 0, duration: 0.68 })
			.to(topArrow, { autoAlpha: 1, y: 0, scale: 1, duration: 0.55 }, "-=0.38")
			.to(topTexts, { autoAlpha: 1, y: 0, duration: 0.62, stagger: 0.1 }, "-=0.35")
			.to(items, { autoAlpha: 1, y: 0, clipPath: "inset(0% 0 0 0)", duration: 0.68, stagger: 0.06 }, "-=0.25")
			.to(itemTitles, { x: 0, duration: 0.58, stagger: 0.06 }, "-=0.6")
			.to(itemTitleContent, { autoAlpha: 1, x: 0, duration: 0.5, stagger: 0.025 }, "-=0.48")
			.to(itemTexts, { autoAlpha: 1, y: 0, duration: 0.5, stagger: 0.025 }, "-=0.42");

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					return;
				}

				timeline.play();
				observer.disconnect();
			});
		}, { threshold: 0.25 });

		observer.observe(areasInside);

		return () => {
			observer.disconnect();
			timeline.kill();
		};
	});
}
function initPartnersAnimation() {
	if (typeof gsap === "undefined") {
		return;
	}

	const partners = document.querySelector("#partners");
	if (!partners) {
		return;
	}

	const boxes = [...partners.querySelectorAll(".box")];
	if (!boxes.length) {
		return;
	}

	const animatedElements = boxes.flatMap((box) => [
		box.querySelector("figure"),
		box.querySelector("figure .img-person"),
		box.querySelector("figcaption .info"),
		box.querySelector("figcaption a"),
		...box.querySelectorAll(".high h3, .high .arrow, .high h4"),
		...box.querySelectorAll(".description p"),
		...box.querySelectorAll(".bookBox .book"),
	]).filter(Boolean);
	const media = gsap.matchMedia();

	media.add("(prefers-reduced-motion: reduce)", () => {
		gsap.set(animatedElements, { clearProps: "all" });
	});

	media.add("(prefers-reduced-motion: no-preference)", () => {
		const timelines = new Map();
		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					return;
				}

				const timeline = timelines.get(entry.target);
				if (timeline) {
					timeline.play();
				}

				observer.unobserve(entry.target);
			});
		}, { threshold: 0.22 });

		boxes.forEach((box) => {
			const figure = box.querySelector("figure");
			const personImage = box.querySelector("figure .img-person");
			const info = box.querySelector("figcaption .info");
			const social = box.querySelector("figcaption a");
			const highItems = [...box.querySelectorAll(".high h3, .high .arrow, .high h4")];
			const paragraphs = [...box.querySelectorAll(".description p")];
			const books = [...box.querySelectorAll(".bookBox .book")];
			const boxElements = [figure, personImage, info, social, ...highItems, ...paragraphs, ...books].filter(Boolean);

			const timeline = gsap.timeline({
				paused: true,
				defaults: {
					ease: "power3.out",
				},
				onComplete: () => gsap.set(boxElements, { clearProps: "all" }),
			});

			gsap.set(figure, { autoAlpha: 0, y: 34, clipPath: "inset(8% 0 0 0)" });
			gsap.set(personImage, { scale: 1.035, transformOrigin: "50% 50%" });
			gsap.set(info, { autoAlpha: 0, y: 24 });
			gsap.set(social, { autoAlpha: 0, scale: 0.9, transformOrigin: "50% 50%" });
			gsap.set(highItems, { autoAlpha: 0, y: 26 });
			gsap.set(paragraphs, { autoAlpha: 0, y: 22 });
			gsap.set(books, { autoAlpha: 0, y: 24 });

			timeline
				.to(figure, { autoAlpha: 1, y: 0, clipPath: "inset(0% 0 0 0)", duration: 0.78 })
				.to(personImage, { scale: 1, duration: 1.1 }, "-=0.78")
				.to(info, { autoAlpha: 1, y: 0, duration: 0.62 }, "-=0.45")
				.to(social, { autoAlpha: 1, scale: 1, duration: 0.52 }, "-=0.36")
				.to(highItems, { autoAlpha: 1, y: 0, duration: 0.6, stagger: 0.08 }, "-=0.22")
				.to(paragraphs, { autoAlpha: 1, y: 0, duration: 0.5, stagger: 0.035 }, "-=0.2")
				.to(books, { autoAlpha: 1, y: 0, duration: 0.55, stagger: 0.08 }, "-=0.2");

			timelines.set(box, timeline);
			observer.observe(box);
		});

		return () => {
			observer.disconnect();
			timelines.forEach((timeline) => timeline.kill());
		};
	});
}
function initTeamAnimation() {
	if (typeof gsap === "undefined") {
		return;
	}

	const team = document.querySelector("#team");
	if (!team) {
		return;
	}

	const elements = [...team.querySelectorAll(".hat, .team-card")];
	if (!elements.length) {
		return;
	}

	const media = gsap.matchMedia();

	media.add("(prefers-reduced-motion: reduce)", () => {
		gsap.set(elements, { clearProps: "all" });
	});

	media.add("(prefers-reduced-motion: no-preference)", () => {
		const timeline = gsap.timeline({
			paused: true,
			defaults: {
				duration: 0.58,
				ease: "power3.out",
			},
			onComplete: () => gsap.set(elements, { clearProps: "all" }),
		});

		gsap.set(elements, { autoAlpha: 0, y: 24 });

		timeline.to(elements, { autoAlpha: 1, y: 0, stagger: 0.08 });

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					return;
				}

				timeline.play();
				observer.disconnect();
			});
		}, { threshold: 0.25 });

		observer.observe(team);

		return () => {
			observer.disconnect();
			timeline.kill();
		};
	});
}
function initBlogAnimation() {
	if (typeof gsap === "undefined") {
		return;
	}

	const blog = document.querySelector("#blog");
	if (!blog) {
		return;
	}

	const topTitle = blog.querySelector(".top h2");
	const topArrow = blog.querySelector(".top h2 a");
	const topText = blog.querySelector(".top p");
	const cards = [...blog.querySelectorAll(".blog-card")];
	const more = blog.querySelector(".more");
	const animatedElements = [topTitle, topArrow, topText, ...cards, more].filter(Boolean);
	const media = gsap.matchMedia();

	media.add("(prefers-reduced-motion: reduce)", () => {
		gsap.set(animatedElements, { clearProps: "all" });
	});

	media.add("(prefers-reduced-motion: no-preference)", () => {
		const timeline = gsap.timeline({
			paused: true,
			defaults: {
				ease: "power3.out",
			},
			onComplete: () => gsap.set(animatedElements, { clearProps: "all" }),
		});

		gsap.set(topTitle, { autoAlpha: 0, x: -34, clipPath: "inset(0 100% 0 0)" });
		gsap.set(topArrow, { autoAlpha: 0, x: -18, scale: 0.86, transformOrigin: "50% 50%" });
		gsap.set(topText, { autoAlpha: 0, x: -32, clipPath: "inset(0 100% 0 0)" });
		gsap.set(cards, { autoAlpha: 0, y: 34, clipPath: "inset(10% 0 0 0)" });
		gsap.set(more, { autoAlpha: 0, x: -20 });

		timeline
			.to(topTitle, { autoAlpha: 1, x: 0, clipPath: "inset(0 0% 0 0)", duration: 0.75 })
			.to(topArrow, { autoAlpha: 1, x: 0, scale: 1, duration: 0.55 }, "-=0.35")
			.to(topText, { autoAlpha: 1, x: 0, clipPath: "inset(0 0% 0 0)", duration: 0.7 }, "-=0.5")
			.to(cards, { autoAlpha: 1, y: 0, clipPath: "inset(0% 0 0 0)", duration: 0.7, stagger: 0.12 }, "-=0.25")
			.to(more, { autoAlpha: 1, x: 0, duration: 0.55 }, "-=0.35");

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					return;
				}

				timeline.play();
				observer.disconnect();
			});
		}, { threshold: 0.25 });

		observer.observe(blog);

		return () => {
			observer.disconnect();
			timeline.kill();
		};
	});
}

function initBlogArchiveAnimation() {
	if (typeof gsap === "undefined") {
		return;
	}

	const blogArchive = document.querySelector("#blogArchive");
	if (!blogArchive) {
		return;
	}

	const topElements = [...blogArchive.querySelectorAll(".blogArchive__top h2, .blogArchive__top p")];
	const filters = blogArchive.querySelector(".blogArchive__filters");
	const cards = [...blogArchive.querySelectorAll(".blog-card")];
	const animatedElements = [...topElements, filters, ...cards].filter(Boolean);
	const media = gsap.matchMedia();

	media.add("(prefers-reduced-motion: reduce)", () => {
		gsap.set(animatedElements, { clearProps: "all" });
	});

	media.add("(prefers-reduced-motion: no-preference)", () => {
		const timeline = gsap.timeline({
			paused: true,
			defaults: {
				ease: "power3.out",
			},
			onComplete: () => gsap.set(animatedElements, { clearProps: "all" }),
		});

		gsap.set(topElements, { autoAlpha: 0, y: 22 });
		gsap.set(filters, { autoAlpha: 0, y: 18 });
		gsap.set(cards, { autoAlpha: 0, y: 28 });

		timeline
			.to(topElements, { autoAlpha: 1, y: 0, duration: 0.58, stagger: 0.07 })
			.to(filters, { autoAlpha: 1, y: 0, duration: 0.5 }, "-=0.28")
			.to(cards, { autoAlpha: 1, y: 0, duration: 0.56, stagger: 0.055 }, "-=0.18");

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					return;
				}

				timeline.play();
				observer.disconnect();
			});
		}, { threshold: 0.18 });

		observer.observe(blogArchive);

		return () => {
			observer.disconnect();
			timeline.kill();
		};
	});
}

function initBlogDetailAnimation() {
	if (typeof gsap === "undefined") {
		return;
	}

	const blogDetail = document.querySelector("#blogDetail");
	if (!blogDetail) {
		return;
	}

	const share = blogDetail.querySelector(".blogDetail__share");
	const headerElements = [...blogDetail.querySelectorAll(".blogDetail__header > *")];
	const cover = blogDetail.querySelector(".blogDetail__cover");
	const coverImage = blogDetail.querySelector(".blogDetail__cover img");
	const bodyElements = [...blogDetail.querySelectorAll(".blogDetail__body > *")];
	const tags = blogDetail.querySelector(".blogDetail__tags");
	const aside = blogDetail.querySelector(".blogDetail__aside");
	const asideItems = [...blogDetail.querySelectorAll(".blogDetail__aside li")];
	const animatedElements = [share, ...headerElements, cover, coverImage, ...bodyElements, tags, aside, ...asideItems].filter(Boolean);
	const media = gsap.matchMedia();

	media.add("(prefers-reduced-motion: reduce)", () => {
		gsap.set(animatedElements, { clearProps: "all" });
	});

	media.add("(prefers-reduced-motion: no-preference)", () => {
		const timeline = gsap.timeline({
			paused: true,
			defaults: {
				ease: "power3.out",
			},
			onComplete: () => gsap.set(animatedElements, { clearProps: "all" }),
		});

		gsap.set(share, { autoAlpha: 0, y: 16 });
		gsap.set(headerElements, { autoAlpha: 0, y: 22 });
		gsap.set(cover, { autoAlpha: 0, y: 28, clipPath: "inset(8% 0 0 0)" });
		gsap.set(coverImage, { scale: 1.035, transformOrigin: "50% 50%" });
		gsap.set(bodyElements, { autoAlpha: 0, y: 22 });
		gsap.set(tags, { autoAlpha: 0, y: 16 });
		gsap.set(aside, { autoAlpha: 0, y: 24 });
		gsap.set(asideItems, { y: 18 });

		timeline
			.to(share, { autoAlpha: 1, y: 0, duration: 0.46 })
			.to(headerElements, { autoAlpha: 1, y: 0, duration: 0.56, stagger: 0.07 }, "-=0.28")
			.to(cover, { autoAlpha: 1, y: 0, clipPath: "inset(0% 0 0 0)", duration: 0.72 }, "-=0.28")
			.to(coverImage, { scale: 1, duration: 0.95 }, "-=0.72")
			.to(bodyElements, { autoAlpha: 1, y: 0, duration: 0.54, stagger: 0.055 }, "-=0.35")
			.to(tags, { autoAlpha: 1, y: 0, duration: 0.46 }, "-=0.18")
			.to(aside, { autoAlpha: 1, y: 0, duration: 0.56 }, "-=1.25")
			.to(asideItems, { y: 0, duration: 0.48, stagger: 0.055 }, "-=0.4");

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					return;
				}

				timeline.play();
				observer.disconnect();
			});
		}, { threshold: 0.16 });

		observer.observe(blogDetail);

		return () => {
			observer.disconnect();
			timeline.kill();
		};
	});
}

function initBoxNewsAnimation() {
	if (typeof gsap === "undefined") {
		return;
	}

	const boxNews = document.querySelector("#boxNews");
	if (!boxNews) {
		return;
	}

	const featured = boxNews.querySelector(".boxNews__featured");
	const hat = boxNews.querySelector(".boxNews__aside .hat");
	const items = [...boxNews.querySelectorAll(".boxNews__aside li")];
	const more = boxNews.querySelector(".boxNews__more");
	const animatedElements = [featured, hat, ...items, more].filter(Boolean);
	const media = gsap.matchMedia();

	media.add("(prefers-reduced-motion: reduce)", () => {
		gsap.set(animatedElements, { clearProps: "all" });
	});

	media.add("(prefers-reduced-motion: no-preference)", () => {
		const timeline = gsap.timeline({
			paused: true,
			defaults: {
				ease: "power2.out",
			},
			onComplete: () => gsap.set(animatedElements, { clearProps: "all" }),
		});

		gsap.set(featured, { autoAlpha: 0, y: 18, scale: 0.99, transformOrigin: "50% 100%" });
		gsap.set(hat, { autoAlpha: 0, y: 12 });
		gsap.set(items, { autoAlpha: 0, y: 16 });
		gsap.set(more, { autoAlpha: 0, y: 12 });

		timeline
			.to(featured, { autoAlpha: 1, y: 0, scale: 1, duration: 0.58 })
			.to(hat, { autoAlpha: 1, y: 0, duration: 0.42 }, "-=0.35")
			.to(items, { autoAlpha: 1, y: 0, duration: 0.46, stagger: 0.055 }, "-=0.25")
			.to(more, { autoAlpha: 1, y: 0, duration: 0.4 }, "-=0.22");

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					return;
				}

				timeline.play();
				observer.disconnect();
			});
		}, { threshold: 0.18 });

		observer.observe(boxNews);

		return () => {
			observer.disconnect();
			timeline.kill();
		};
	});
}

function initBoxArticlesAnimation() {
	if (typeof gsap === "undefined") {
		return;
	}

	const boxArticles = document.querySelector("#boxArticles");
	if (!boxArticles) {
		return;
	}

	const topElements = [...boxArticles.querySelectorAll(".boxArticles__top .hat, .boxArticles__nav button")];
	const cards = [...boxArticles.querySelectorAll(".blog-card")];
	const more = boxArticles.querySelector(".boxArticles__more");
	const animatedElements = [...topElements, ...cards, more].filter(Boolean);
	const media = gsap.matchMedia();

	media.add("(prefers-reduced-motion: reduce)", () => {
		gsap.set(animatedElements, { clearProps: "all" });
	});

	media.add("(prefers-reduced-motion: no-preference)", () => {
		const timeline = gsap.timeline({
			paused: true,
			defaults: {
				ease: "power2.out",
			},
			onComplete: () => gsap.set(animatedElements, { clearProps: "all" }),
		});

		gsap.set(topElements, { autoAlpha: 0, y: 12 });
		gsap.set(cards, { autoAlpha: 0, y: 18 });
		gsap.set(more, { autoAlpha: 0, y: 12 });

		timeline
			.to(topElements, { autoAlpha: 1, y: 0, duration: 0.42, stagger: 0.06 })
			.to(cards, { autoAlpha: 1, y: 0, duration: 0.5, stagger: 0.06 }, "-=0.18")
			.to(more, { autoAlpha: 1, y: 0, duration: 0.4 }, "-=0.2");

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					return;
				}

				timeline.play();
				observer.disconnect();
			});
		}, { threshold: 0.18 });

		observer.observe(boxArticles);

		return () => {
			observer.disconnect();
			timeline.kill();
		};
	});
}
function initNewsletterAnimation() {
	if (typeof gsap === "undefined") {
		return;
	}

	const newsletter = document.querySelector("#newsletter");
	if (!newsletter) {
		return;
	}

	const textElements = [...newsletter.querySelectorAll(".texts h2, .texts p")];
	const line = newsletter.querySelector("hr");
	const boxForm = newsletter.querySelector(".boxForm");
	const mailIcon = newsletter.querySelector(".boxForm > img");
	const formElements = [...newsletter.querySelectorAll("form input, form .btn")];
	const vector = newsletter.querySelector(".vector");
	const animatedElements = [...textElements, line, boxForm, mailIcon, ...formElements, vector].filter(Boolean);
	const media = gsap.matchMedia();

	media.add("(prefers-reduced-motion: reduce)", () => {
		gsap.set(animatedElements, { clearProps: "all" });
	});

	media.add("(prefers-reduced-motion: no-preference)", () => {
		const timeline = gsap.timeline({
			paused: true,
			defaults: {
				ease: "power3.out",
			},
			onComplete: () => gsap.set(animatedElements, { clearProps: "all" }),
		});

		gsap.set(textElements, { autoAlpha: 0, x: -34, clipPath: "inset(0 100% 0 0)" });
		gsap.set(line, { scaleX: 0, transformOrigin: "left center" });
		gsap.set(boxForm, { autoAlpha: 0, x: -36, clipPath: "inset(0 100% 0 0)" });
		gsap.set(mailIcon, { autoAlpha: 0, x: -18, scale: 0.88, transformOrigin: "50% 50%" });
		gsap.set(formElements, { autoAlpha: 0, x: -24 });
		gsap.set(vector, { autoAlpha: 0, x: -28 });

		timeline
			.to(textElements, { autoAlpha: 1, x: 0, clipPath: "inset(0 0% 0 0)", duration: 0.65, stagger: 0.1 })
			.to(line, { scaleX: 1, duration: 0.72 }, "-=0.35")
			.to(boxForm, { autoAlpha: 1, x: 0, clipPath: "inset(0 0% 0 0)", duration: 0.75 }, "-=0.5")
			.to(vector, { autoAlpha: 1, x: 0, duration: 0.75 }, "-=0.7")
			.to(mailIcon, { autoAlpha: 1, x: 0, scale: 1, duration: 0.55 }, "-=0.45")
			.to(formElements, { autoAlpha: 1, x: 0, duration: 0.52, stagger: 0.07 }, "-=0.35");

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					return;
				}

				timeline.play();
				observer.disconnect();
			});
		}, { threshold: 0.3 });

		observer.observe(newsletter);

		return () => {
			observer.disconnect();
			timeline.kill();
		};
	});
}

function initProjectsIntroAnimation() {
	if (typeof gsap === "undefined") {
		return;
	}

	const projectsTop = document.querySelector("#projects .top");
	if (!projectsTop) {
		return;
	}

	const textElements = [...projectsTop.querySelectorAll(".texts h2, .texts p")];
	if (!textElements.length) {
		return;
	}

	const media = gsap.matchMedia();

	media.add("(prefers-reduced-motion: reduce)", () => {
		gsap.set(textElements, { clearProps: "all" });
	});

	media.add("(prefers-reduced-motion: no-preference)", () => {
		const tween = gsap.fromTo(
			textElements,
			{ autoAlpha: 0, y: 24 },
			{
				autoAlpha: 1,
				y: 0,
				duration: 0.62,
				stagger: 0.08,
				ease: "power3.out",
				paused: true,
				onComplete: () => gsap.set(textElements, { clearProps: "all" }),
			},
		);

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					return;
				}

				tween.play();
				observer.disconnect();
			});
		}, { threshold: 0.4 });

		observer.observe(projectsTop);

		return () => {
			observer.disconnect();
			tween.kill();
		};
	});
}

function initProjectsLogoAnimation() {
	if (typeof gsap === "undefined") {
		return;
	}

	const logo = document.querySelector("#projects .container > img.logo");
	if (!logo) {
		return;
	}

	const media = gsap.matchMedia();

	media.add("(prefers-reduced-motion: no-preference)", () => {
		fetch(logo.getAttribute("src"))
			.then((response) => {
				if (!response.ok) {
					throw new Error("Falha ao carregar o SVG do logo");
				}

				return response.text();
			})
			.then((svgText) => {
				const parser = new DOMParser();
				const svgDocument = parser.parseFromString(svgText, "image/svg+xml");
				const svg = svgDocument.querySelector("svg");

				if (!svg) {
					return;
				}

				svg.classList.add(...logo.classList);
				svg.setAttribute("role", "img");
				svg.setAttribute("aria-label", logo.getAttribute("alt") || "EGF Construtora");
				logo.replaceWith(svg);

				const shapes = [...svg.querySelectorAll("path, rect, circle, ellipse, line, polyline, polygon")];
				if (!shapes.length) {
					return;
				}

				const outline = shapes.map((shape) => {
					const clone = shape.cloneNode(true);
					clone.removeAttribute("fill");
					clone.setAttribute("stroke", "currentColor");
					clone.setAttribute("stroke-width", "0.9");
					clone.setAttribute("vector-effect", "non-scaling-stroke");
					shape.parentNode.insertBefore(clone, shape);
					return clone;
				});
				const animatedElements = [...outline, ...shapes];
				const timeline = gsap.timeline({
					paused: true,
					defaults: {
						ease: "power3.out",
					},
					onComplete: () => {
						gsap.set(animatedElements, { clearProps: "all" });
						outline.forEach((shape) => shape.remove());
					},
				});

				outline.forEach((shape) => {
					const length = typeof shape.getTotalLength === "function" ? shape.getTotalLength() : 0;
					shape.style.strokeDasharray = length;
					shape.style.strokeDashoffset = length;
				});

				gsap.set(svg, { autoAlpha: 0, y: 24 });
				gsap.set(shapes, { autoAlpha: 0 });

				timeline
					.to(svg, { autoAlpha: 1, y: 0, duration: 0.48 })
					.to(outline, { strokeDashoffset: 0, duration: 1.05, stagger: 0.04 }, "-=0.18")
					.to(shapes, { autoAlpha: 1, duration: 0.45 }, "-=0.32")
					.to(outline, { autoAlpha: 0, duration: 0.28 }, "-=0.22");

				const observer = new IntersectionObserver((entries) => {
					entries.forEach((entry) => {
						if (!entry.isIntersecting) {
							return;
						}

						timeline.play();
						observer.disconnect();
					});
				}, { threshold: 0.35 });

				observer.observe(svg);
			})
			.catch(() => {});
	});
}

function initProjectsCardsAnimation() {
	const projects = document.querySelector("#projects");
	if (!projects) {
		return;
	}

	const cards = [...projects.querySelectorAll(".projectCards > li")];
	if (cards.length < 2) {
		return;
	}

	const motionQuery = window.matchMedia("(prefers-reduced-motion: no-preference)");
	const desktopQuery = window.matchMedia("(min-width: 769px)");
	let ticking = false;

	function clamp(value, min, max) {
		return Math.min(Math.max(value, min), max);
	}

	function clearCards() {
		cards.forEach((card) => {
			const content = card.querySelector("a");
			if (!content) {
				return;
			}

			content.style.removeProperty("transform");
			content.style.removeProperty("opacity");
		});
	}

	function updateCards() {
		ticking = false;

		if (!motionQuery.matches || !desktopQuery.matches) {
			clearCards();
			return;
		}

		const stickyTop = parseFloat(window.getComputedStyle(cards[0]).top) || 0;
		const range = Math.max(window.innerHeight - stickyTop, 1);

		cards.forEach((card, index) => {
			const nextCard = cards[index + 1];
			const content = card.querySelector("a");
			if (!content) {
				return;
			}

			if (!nextCard) {
				content.style.removeProperty("transform");
				content.style.removeProperty("opacity");
				return;
			}

			const nextTop = nextCard.getBoundingClientRect().top;
			const progress = clamp((window.innerHeight - nextTop) / range, 0, 1);
			const scale = 1 - (0.08 * progress);
			const opacity = 1 - (0.22 * progress);

			content.style.transform = `scale(${scale})`;
			content.style.opacity = opacity.toFixed(3);
		});
	}

	function requestUpdate() {
		if (ticking) {
			return;
		}

		ticking = true;
		requestAnimationFrame(updateCards);
	}

	window.addEventListener("scroll", requestUpdate, { passive: true });
	window.addEventListener("resize", requestUpdate, { passive: true });
	motionQuery.addEventListener("change", requestUpdate);
	desktopQuery.addEventListener("change", requestUpdate);
	requestUpdate();
}

function initProjectDetailAnimation() {
	if (typeof gsap === "undefined") {
		return;
	}

	const projectDetail = document.querySelector("#projectDetail");
	if (!projectDetail) {
		return;
	}

	const share = projectDetail.querySelector(".projectDetail__share");
	const main = projectDetail.querySelector(".projectDetail__main");
	const aside = projectDetail.querySelector(".projectDetail__aside");
	const progress = projectDetail.querySelector(".projectProgress");
	const gallery = projectDetail.querySelector(".projectGallery");
	const media = gsap.matchMedia();

	function getElements() {
		return [
			share,
			main?.querySelector(".projectDetail__cover"),
			main?.querySelector(".projectDetail__cover img"),
			main?.querySelector(".smallTitle"),
			main?.querySelector(":scope > p"),
			main?.querySelector("blockquote"),
			progress?.querySelector("h3"),
			progress?.querySelector(".projectProgress__summary"),
			...(progress?.querySelectorAll(".projectProgress__list li") || []),
			gallery?.querySelector(".projectGallery__top"),
			...(gallery?.querySelectorAll(".projectGallery__list li") || []),
			aside,
		].filter(Boolean);
	}

	media.add("(prefers-reduced-motion: reduce)", () => {
		gsap.set(getElements(), { clearProps: "all" });
	});

	media.add("(prefers-reduced-motion: no-preference)", () => {
		const timelines = [];
		const observers = [];

		function playOnView(section, timeline, threshold = 0.24) {
			if (!section) {
				return;
			}

			const observer = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (!entry.isIntersecting) {
						return;
					}

					timeline.play();
					observer.disconnect();
				});
			}, { threshold });

			observer.observe(section);
			observers.push(observer);
		}

		const introElements = [
			share,
			main?.querySelector(".projectDetail__cover"),
			main?.querySelector(".smallTitle"),
			main?.querySelector(":scope > p"),
			main?.querySelector("blockquote"),
			aside,
		].filter(Boolean);
		const coverImage = main?.querySelector(".projectDetail__cover img");

		if (introElements.length) {
			const timeline = gsap.timeline({
				paused: true,
				defaults: {
					ease: "power3.out",
				},
				onComplete: () => gsap.set([...introElements, coverImage].filter(Boolean), { clearProps: "all" }),
			});

			gsap.set(share, { autoAlpha: 0, y: 16 });
			gsap.set(main?.querySelector(".projectDetail__cover"), { autoAlpha: 0, y: 28, clipPath: "inset(8% 0 0 0)" });
			gsap.set(coverImage, { scale: 1.035, transformOrigin: "50% 50%" });
			gsap.set([main?.querySelector(".smallTitle"), main?.querySelector(":scope > p"), main?.querySelector("blockquote")].filter(Boolean), { autoAlpha: 0, y: 24 });
			gsap.set(aside, { autoAlpha: 0, y: 26 });

			timeline
				.to(share, { autoAlpha: 1, y: 0, duration: 0.46 })
				.to(main?.querySelector(".projectDetail__cover"), { autoAlpha: 1, y: 0, clipPath: "inset(0% 0 0 0)", duration: 0.72 }, "-=0.3")
				.to(coverImage, { scale: 1, duration: 0.95 }, "-=0.72")
				.to([main?.querySelector(".smallTitle"), main?.querySelector(":scope > p"), main?.querySelector("blockquote")].filter(Boolean), { autoAlpha: 1, y: 0, duration: 0.58, stagger: 0.075 }, "-=0.42")
				.to(aside, { autoAlpha: 1, y: 0, duration: 0.62 }, "-=0.58");

			timelines.push(timeline);
			playOnView(projectDetail, timeline, 0.16);
		}

		if (progress) {
			const progressElements = [
				progress.querySelector("h3"),
				progress.querySelector(".projectProgress__summary"),
				...(progress.querySelectorAll(".projectProgress__list li") || []),
			].filter(Boolean);
			const timeline = gsap.timeline({
				paused: true,
				defaults: {
					ease: "power3.out",
				},
				onComplete: () => gsap.set(progressElements, { clearProps: "all" }),
			});

			gsap.set(progressElements, { autoAlpha: 0, y: 24 });
			timeline.to(progressElements, { autoAlpha: 1, y: 0, duration: 0.56, stagger: 0.055 });

			timelines.push(timeline);
			playOnView(progress, timeline, 0.24);
		}

		if (gallery) {
			const galleryElements = [
				gallery.querySelector(".projectGallery__top"),
				...(gallery.querySelectorAll(".projectGallery__list li") || []),
			].filter(Boolean);
			const timeline = gsap.timeline({
				paused: true,
				defaults: {
					ease: "power3.out",
				},
				onComplete: () => gsap.set(galleryElements, { clearProps: "all" }),
			});

			gsap.set(galleryElements, { autoAlpha: 0, y: 22 });
			timeline.to(galleryElements, { autoAlpha: 1, y: 0, duration: 0.52, stagger: 0.075 });

			timelines.push(timeline);
			playOnView(gallery, timeline, 0.28);
		}

		return () => {
			observers.forEach((observer) => observer.disconnect());
			timelines.forEach((timeline) => timeline.kill());
		};
	});
}
function initContactAnimation() {
	if (typeof gsap === "undefined") {
		return;
	}

	const contact = document.querySelector("#contact");
	if (!contact) {
		return;
	}

	const introElements = [...contact.querySelectorAll(".contactIntro__top > *")];
	const form = contact.querySelector(".contactForm");
	const fields = [...contact.querySelectorAll(".contactForm__fields > *")];
	const info = contact.querySelector(".contactInfo");
	const infoGroups = [...contact.querySelectorAll(".contactInfo__group")];
	const animatedElements = [...introElements, form, ...fields, info, ...infoGroups].filter(Boolean);
	const media = gsap.matchMedia();

	media.add("(prefers-reduced-motion: reduce)", () => {
		gsap.set(animatedElements, { clearProps: "all" });
	});

	media.add("(prefers-reduced-motion: no-preference)", () => {
		const timeline = gsap.timeline({
			paused: true,
			defaults: {
				ease: "power3.out",
			},
			onComplete: () => gsap.set(animatedElements, { clearProps: "all" }),
		});

		gsap.set(introElements, { autoAlpha: 0, y: 24 });
		gsap.set(form, { autoAlpha: 0, y: 28, clipPath: "inset(6% 0 0 0)" });
		gsap.set(fields, { autoAlpha: 0, y: 14 });
		gsap.set(info, { autoAlpha: 0, y: 28, clipPath: "inset(6% 0 0 0)" });
		gsap.set(infoGroups, { autoAlpha: 0, y: 16 });

		timeline
			.to(introElements, { autoAlpha: 1, y: 0, duration: 0.58, stagger: 0.08 })
			.to([form, info], { autoAlpha: 1, y: 0, clipPath: "inset(0% 0 0 0)", duration: 0.68, stagger: 0.08 }, "-=0.2")
			.to(fields, { autoAlpha: 1, y: 0, duration: 0.42, stagger: 0.045 }, "-=0.38")
			.to(infoGroups, { autoAlpha: 1, y: 0, duration: 0.46, stagger: 0.07 }, "-=0.48");

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					return;
				}

				timeline.play();
				observer.disconnect();
			});
		}, { threshold: 0.22 });

		observer.observe(contact);

		return () => {
			observer.disconnect();
			timeline.kill();
		};
	});
}
function initFooterAnimation() {
	if (typeof gsap === "undefined") {
		return;
	}

	const footer = document.querySelector("#footer");
	if (!footer) {
		return;
	}

	const columns = [
		footer.querySelector(".footer__brand"),
		footer.querySelector(".footer__nav"),
		footer.querySelector(".footer__form"),
	].filter(Boolean);
	const bottomElements = [...footer.querySelectorAll(".footer__bottom > *")];
	const animatedElements = [...columns, ...bottomElements].filter(Boolean);
	const media = gsap.matchMedia();

	media.add("(prefers-reduced-motion: reduce)", () => {
		gsap.set(animatedElements, { clearProps: "all" });
	});

	media.add("(prefers-reduced-motion: no-preference)", () => {
		const timeline = gsap.timeline({
			paused: true,
			defaults: {
				ease: "power2.out",
			},
			onComplete: () => gsap.set(animatedElements, { clearProps: "all" }),
		});

		gsap.set(columns, { autoAlpha: 0, y: 24 });
		gsap.set(bottomElements, { autoAlpha: 0, y: 14 });

		timeline
			.to(columns, { autoAlpha: 1, y: 0, duration: 0.56, stagger: 0.08 })
			.to(bottomElements, { autoAlpha: 1, y: 0, duration: 0.42, stagger: 0.05 }, "-=0.25");

		const observer = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) {
					return;
				}

				timeline.play();
				observer.disconnect();
			});
		}, { threshold: 0.18 });

		observer.observe(footer);

		return () => {
			observer.disconnect();
			timeline.kill();
		};
	});
}
